import React from 'react';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { api } from '@api';
import {
  IncidentClassification,
  IncidentSubClassification,
} from '@models/Incident';

import { TitleDescriptionIncidentForm } from '../components/TitleDescriptionIncidentForm';

export const ParkingOtherMessageForm = ({
  customTranslations,
}: ParsedEntry<IWidget>) => (
  <TitleDescriptionIncidentForm
    incidentKind="ParkingOtherMessage"
    postIncident={api.incidents.postGenericDefectIncident}
    translations={customTranslations}
    classifications={{
      classification: IncidentClassification.DEFECT_REPORT_PUBLIC,
      subClassification: IncidentSubClassification.PARKING_ISSUE,
    }}
  />
);
